var exports = {
  "f": "manualCopyUrl__np6TfS",
};

module.exports = exports;
